import { render, staticRenderFns } from "./BillingIntervals.vue?vue&type=template&id=1185971c&"
import script from "./BillingIntervals.vue?vue&type=script&lang=js&"
export * from "./BillingIntervals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports